import { useMemo } from 'react';

import { useRetrieveAllowanceBoost } from '../hooks/use-retrieve-allowance-boost';
import { Provider } from '../types/rewards';

export const useAllowanceBoostId = () => {
	const { data, isLoading } = useRetrieveAllowanceBoost(
		{
			params: {
				filters: {
					category_ids: [],
					provider: Provider.Bonusly,
				},
				pagination: {
					enabled: false,
				},
			},
		},
		true,
		false
	);

	const id = useMemo(() => {
		if (!data) {
			return '';
		}

		return data?.data?.find((items) => items.item.provider === Provider.Bonusly)?.id;
	}, [data]);

	return { id, isLoading };
};
